import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatPrice(amount: string | number, currencyCode: string = 'ILS'): string {
  const price = typeof amount === 'string' ? parseFloat(amount) : amount;
  const formattedNumber = Math.round(price).toLocaleString('he-IL');
  
  if (currencyCode === 'ILS') {
    return `₪${formattedNumber}`;
  }
  return `${currencyCode} ${formattedNumber}`;
}
